import { render, staticRenderFns } from "./LiveRemotePage.vue?vue&type=template&id=56de6124&scoped=true"
import script from "./LiveRemotePage.vue?vue&type=script&lang=js"
export * from "./LiveRemotePage.vue?vue&type=script&lang=js"
import style0 from "./LiveRemotePage.vue?vue&type=style&index=0&id=56de6124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de6124",
  null
  
)

export default component.exports